var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgView = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 34 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5836 11.0848C33.2816 10.6718 26.0874 0.971313 16.899 0.971313C7.71067 0.971313 0.516087 10.6718 0.214475 11.0844C-0.0714916 11.4763 -0.0714916 12.0078 0.214475 12.3996C0.516087 12.8127 7.71067 22.5131 16.899 22.5131C26.0874 22.5131 33.2816 12.8126 33.5836 12.3999C33.8699 12.0082 33.8699 11.4763 33.5836 11.0848ZM16.899 20.2847C10.1308 20.2847 4.26884 13.8463 2.53356 11.7415C4.26659 9.63481 10.1163 3.19977 16.899 3.19977C23.6669 3.19977 29.5285 9.63705 31.2645 11.743C29.5315 13.8496 23.6818 20.2847 16.899 20.2847Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8995 5.05676C13.2133 5.05676 10.2141 8.05591 10.2141 11.7422C10.2141 15.4285 13.2133 18.4276 16.8995 18.4276C20.5858 18.4276 23.585 15.4285 23.585 11.7422C23.585 8.05591 20.5858 5.05676 16.8995 5.05676ZM16.8995 16.1991C14.4419 16.1991 12.4426 14.1998 12.4426 11.7422C12.4426 9.28461 14.442 7.28528 16.8995 7.28528C19.3571 7.28528 21.3564 9.28461 21.3564 11.7422C21.3564 14.1998 19.3572 16.1991 16.8995 16.1991Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgView, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/view.482b5246.svg";
export { ForwardRef as ReactComponent };